// extracted by mini-css-extract-plugin
export default {"caption":"h6s5FAVY","credits":"R9psGU8c"};